// Map verb short to long names
export const VERBS = {
  get: "GET",
  options: "OPTS",
  post: "POST",
  put: "PUT",
  patch: "PATCH",
  delete: "DEL",
}

// Priority of verbs to display
const VERB_PRIORITY = Object.keys(VERBS)

// Prioritize an array by verb
export const prioritize = (a, b) => VERB_PRIORITY.indexOf(a.verb) - VERB_PRIORITY.indexOf(b.verb)

export const sortBy = (key) => (a, b) => {
  if (a[key] < b[key]) {
    return -1
  }
  if (a[key] > b[key]) {
    return 1
  }
  return 0
}
